import React from 'react';
import './MModalButton.scss';
import MModal from '../MModal';

class MModalButton extends React.PureComponent{

	constructor(props) {
    super(props);
    this.state = { isOpen: false };
  }

  toggleModal = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  render() {
    return (
      <div>

        <a onClick={this.toggleModal} className="MModal_Button_Hey"><strong>{this.props.title}</strong></a>

				<br/><br/>

        <MModal show={this.state.isOpen} onClose={this.toggleModal}>
          {this.props.children}
        </MModal>

				<br/><br/>

      </div>
    );
  }

}

export default MModalButton;
